const routes = [
    {
        path: "/prep/attendance/entry",
        component: () => import("../pages/Entry"),
        meta: {
            isAuthenticated: true,
            permission: "prepattendance_index"
        }
    }
];

export default routes;
